module.exports = __webpack_public_path__ + "VIPC5.png?f784d80540bd3f43dbd9087b2b1ebec7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/cycling/VIPC5.png
// module id = 68
// module chunks = 0